// extracted by mini-css-extract-plugin
export default {"navigation":"FooterNavList_navigation__IgmVV","header":"FooterNavList_header__3ELR3","items":"FooterNavList_items__gB+Kz"};